export const GET_SAGE_TOKEN_STATUS = gql`
    query GetSageTokenStatus {
        getSageTokenStatus {
            accessTokenExpires
            refreshTokenExpires
        }
    }
`;
